import { GLDistributionTableMultiSource } from "../../../backoffice/src/GLDistributionTableMultiSource";
import { DataHeader, DataSource, HorizontalSpacer, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoiceHistory extends Layout {
    dataheaderMiscInvoiceHistory: DataHeader;
    glDistributionTable: GLDistributionTableMultiSource;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerTax: HorizontalSpacer;
    layoutImageTable: Layout;
    layoutMiscInvoiceDetailTable: Layout;
    layoutMiscInvoiceTaxHistoryTable: Layout;
    sourceExciseTaxMiscBillHist: DataSource;
    sourceGLDistribution: DataSource;
    sourceMiscBillHist: DataSource;
    sourceMiscBillHistDetail: DataSource;
    tabExciseTaxes: Tab;
    tabGeneral: Tab;
    tabGlDistribution: Tab;
    tabImages: Tab;
    tabInterfaces: Tab;
    tabInvoiceDetail: Tab;
    tabsetMiscInvoiceHistory: Tabset;
    textboxAllocationCode: Textbox;
    textboxBillDate: Textbox;
    textboxBillType: Textbox;
    textboxBillingUserId: Textbox;
    textboxCustomerId: Textbox;
    textboxDetailGridTotalWithTaxes: Textbox;
    textboxGpExported: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxOrderId: Textbox;
    textboxReferenceNumber: Textbox;
    textboxRemark: Textbox;
    textboxTaxGridTotalCharges: Textbox;
    textboxTaxGridTotalWithTaxes: Textbox;
    textboxTotalCharges: Textbox;
}
